import { DESKTOP_TOP_NAV_V3_HEIGHT } from '@dtx-company/true-common/src/constants/layout'
import { useMemo } from 'react'
import { useProUpsellBannerState } from '@app/code/src/components/Homepage/ProUpsellBanner/ProUpsellBanner.hooks'
import { useTrialBannerState } from '@app/code/src/components/Homepage/TrialBanner/useTrialBannerState'

export const useV3NavigationTopOffset = (): {
  sideNavTopOffset: number
  topNavTopOffset: number
} => {
  const { displayProUpsellTopNavBanner, bannerHeight } = useProUpsellBannerState()
  const { displayTrialBanner } = useTrialBannerState()
  const { sideNavTopOffset, topNavTopOffset } = useMemo(() => {
    const bannerTopGutterHeight =
      displayProUpsellTopNavBanner || displayTrialBanner ? bannerHeight : 0
    return {
      sideNavTopOffset: DESKTOP_TOP_NAV_V3_HEIGHT + bannerTopGutterHeight,
      topNavTopOffset: bannerTopGutterHeight
    }
  }, [displayProUpsellTopNavBanner, displayTrialBanner, bannerHeight])
  return { sideNavTopOffset, topNavTopOffset }
}
